module.exports = __webpack_public_path__ + "static/media/c02-01-3.f76e6c48.png";